// Variants reference: https://webcode.tools/generators/css/keyframe-animation
export var CssAnimationVariants;
(function (CssAnimationVariants) {
    CssAnimationVariants["SLIDE_IN"] = "SLIDE_IN";
})(CssAnimationVariants || (CssAnimationVariants = {}));
//# sourceMappingURL=variant.js.map